import PropTypes from 'prop-types'
import CreateEditModal from 'common/components/modules/modal-wrapper';

const StoriesConfirmDialogs = ({
   type,
   isMobile,
   onCloseModal,
}) => {

   const MODAL_STATES_BY_TYPES = {
      video_upload_limit: {
         icon: 'warning',
         iconColor: 'warning',
         title: 'Upload limit exceeded',
         description: 'Stories are limited to 3GB uploads. There are no restrictions on time length, if the upload is under 3 GB.',
         withoutCancelButton: true,
         buttonText: 'Ok',
         action: onCloseModal,
      },
   }

   if(!MODAL_STATES_BY_TYPES[type])  {
      return null
   }

   return (
      <CreateEditModal
         type='confirm'
         onCloseModal={ onCloseModal }
         isMobile={ isMobile }
         iconSize='2xl'
         primaryButtonClassName='!px-[14px]'
         confirmButtonProperties={ {
            textMarginX: '0',
         } }
         { ...MODAL_STATES_BY_TYPES[type] }
      />
   )
}

StoriesConfirmDialogs.propTypes = {
   type: PropTypes.string,
   isMobile: PropTypes.bool,
   onCloseModal: PropTypes.func,
}

export default StoriesConfirmDialogs;
